// Packages
import PropTypes from 'prop-types'

// Components
import PlacementForm from 'modules/Placements/components/Form';

// Other
import useApi from 'hooks/useApi';

const PlacementCreateScreen = ({ onClose, onSubmit }) => {

    const { post: createItem, errors } = useApi('/placements',  false)

	const submit = async (values) => {

        if( await createItem(values, 'Placement created!') ) {
    
            onSubmit();
        }
    }


    return(
        <PlacementForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

PlacementCreateScreen.propTypes = {
	onClose: PropTypes.func,
	onSubmit: PropTypes.func,
}

PlacementCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default PlacementCreateScreen;